import { useGetHistoryRenewVisaDocumentGroupList } from "@/api/services/main/renew-visa";
import { Pagination } from "@/components/elements/Pagination";
import { Table } from "@/components/elements/Table";
import { ExpandRenewVisaHistoryListBtn } from "@/features/renew-visa/components/ExpandRenewVisaHistoryListBtn";
import { useMakeHistoryRenewVisaColumns } from "@/features/renew-visa/hook/useMakeHistoryRenewVisaColumns";
import { useTable } from "@/hooks/useTable";
import { divider } from "@/theme/colors";
import { Stack } from "@mui/material";
import styled from "styled-components";

export const RenewVisaHistoryListPage = () => {
  const { data: historyRenewVisaDocumentList, isLoading } = useGetHistoryRenewVisaDocumentGroupList();

  const columns = useMakeHistoryRenewVisaColumns();

  const { table } = useTable({
    columns,
    rows: historyRenewVisaDocumentList?.data ?? [],
    muiTableHeadCellProps: { sx: { backgroundColor: divider.low } },
  });

  return (
    <RenewVisaListWrapper gap={3}>
      <Stack direction="row" gap={2} alignItems="center">
        <Pagination totalPage={historyRenewVisaDocumentList?.pagination.totalPage} />
        <ExpandRenewVisaHistoryListBtn />
      </Stack>
      <Table table={table} isLoading={isLoading} />
    </RenewVisaListWrapper>
  );
};

const RenewVisaListWrapper = styled(Stack)`
  background-color: #ffffff;
  padding: 24px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;
